import { twcn } from '@web/ui/core/utils';

type StackedBarTone =
  | 'green'
  | 'green-soft'
  | 'ai'
  | 'ai-soft'
  | 'brand'
  | 'amber'
  | 'red'
  | 'gray'
  | 'hatch';

export interface StackedSegment {
  key: string;
  value: number;
  tone: StackedBarTone;
}

const TONE: Record<StackedBarTone, string> = {
  green: 'bg-tone-green-fg',
  'green-soft': 'bg-tone-green-fg/50',
  ai: 'bg-ai',
  'ai-soft': 'bg-ai/30',
  brand: 'bg-primary',
  amber: 'bg-tone-amber-fg',
  red: 'bg-tone-red-fg',
  gray: 'bg-tone-gray-tint',
  hatch: 'bg-tone-gray-fg/25',
};

interface StackedBarProps {
  segments: readonly StackedSegment[];
  /** Leitura da barra inteira para leitores de tela (os segmentos são decorativos). */
  label: string;
  size?: 'sm' | 'md';
}

/**
 * Barra segmentada proporcional: cada segmento ocupa a fração do seu `value` no total.
 * Segmentos com valor 0 não aparecem.
 */
export function StackedBar({ segments, label, size = 'sm' }: Readonly<StackedBarProps>) {
  return (
    <span
      role="img"
      aria-label={label}
      className={twcn(
        'flex w-full overflow-hidden rounded-pill bg-tone-gray-tint',
        size === 'sm' ? 'h-2' : 'h-3.5',
      )}
    >
      {segments
        .filter((s) => s.value > 0)
        .map((s) => (
          <span
            key={s.key}
            aria-hidden
            className={twcn('h-full', TONE[s.tone])}
            // eslint-disable-next-line voll/no-inline-style -- largura proporcional ao dado: não existe utilitário para um valor contínuo
            style={{ flexGrow: s.value, flexBasis: 0 }}
          />
        ))}
    </span>
  );
}
